import { getFunctions, httpsCallable } from "firebase/functions";

type PresenceResponse = {
  success: boolean;
  activeParticipantsAmount?: number;
};

const functions = getFunctions();

export async function joinRoomPresence(
  roomId: string,
  name?: string,
): Promise<PresenceResponse> {
  const callable = httpsCallable(functions, "joinRoomPresence");
  const result = await callable({ roomId, name });
  return result.data as PresenceResponse;
}

export async function heartbeatRoomPresence(
  roomId: string,
): Promise<PresenceResponse> {
  const callable = httpsCallable(functions, "heartbeatRoomPresence");
  const result = await callable({ roomId });
  return result.data as PresenceResponse;
}

export async function leaveRoomPresence(
  roomId: string,
): Promise<PresenceResponse> {
  const callable = httpsCallable(functions, "leaveRoomPresence");
  const result = await callable({ roomId });
  return result.data as PresenceResponse;
}
